import {inject, Injectable} from '@angular/core';
import {LoggableEntity} from '../../models/error/LoggableEntity';
import {map, Observable} from 'rxjs';
import {ErrorFilter} from '../../models/filter/ErrorFilter';
import {ODataQueryBuilderService} from '../requestHelper/odata-query-builder.service';

@Injectable({
    providedIn: 'root'
})
export abstract class LoggableErrorEntityService<T extends LoggableEntity> {
    protected queryBuilder: ODataQueryBuilderService = inject(ODataQueryBuilderService);

    public getAll(errorFilter: ErrorFilter, top: number, skip: number): Observable<T[]> {
        return this.getAllWithFilter(this.createODataQueryForAllErrorItems(errorFilter, top, skip));
    }

    public getById(id: string): Observable<T> {
        return this.getAllWithFilter(this.createODataQueryForSpecificErrorItem(id)).pipe(
            map(errors => errors[0])
        )
    }

    public abstract getAmountOfErrorItems(errorFilter: ErrorFilter): Observable<number>;

    protected createODataQueryForAllErrorItems(errorFilter: ErrorFilter, top?: number, skip?: number): string {
        this.applyBaseErrorFiltersForAllErrorItems(errorFilter);
        if (errorFilter.applications.length > 0) {
            this.queryBuilder.addFilter("ApplicationId in (" + errorFilter.applications.map(application => `${application.id}`).join(', ') + ")");
        }

        if (skip) {
            this.queryBuilder.setSkip(skip);
        }

        if (top) {
            this.queryBuilder.setTop(top);
        }

        return this.queryBuilder.build();
    }

    protected abstract getAllWithFilter(filter: string): Observable<T[]>;

    protected abstract createODataQueryForSpecificErrorItem(id: string): string;

    protected abstract applyBaseErrorFiltersForAllErrorItems(errorFilter: ErrorFilter): void;
}
